export default {
  Groups: {
    HEADING: 'Recharge Group',
    NEW: 'Connect a Xero Organisation',
    DISCONNECTED: 'Some entities are disconnected from Xero',
    RATE_LIMITED: "Some entities have reached Xero's daily API rate limit",
    START_DATE: 'Start using Mayday from:',
    Edit: {
      TITLE: 'Edit Group',
      NAME: 'Name:',
    },
    Entity: {
      EDIT: 'Edit entity',
      NUM_RULES: ['{{count}} rule', '{{count}} rules'],
      NEW_RULE: 'Add new {{type}} rule for {{name}}',
      NEED_MORE: 'Connect more entities to create rules between them',
      Delete: {
        TITLE: 'Delete {{name}}',
        BODY: 'Are you sure you want to remove {{entityName}} from {{groupName}}?',
      },
      Archive: {
        TITLE: 'Archive {{name}}',
        BODY: 'Are you sure you want to archive {{entityName}}? It will be disconnected from Xero and it will not appear in any future calculations. If you have a subscription, the price you pay will automatically adjust.',
        Restore: {
          TITLE: 'Restore {{name}}',
          BODY: 'Are you sure you want to restore {{entityName}}? If you have a subscription, the price you pay will automatically adjust.',
        },
      },
      CONNECTED: 'Connected to Xero',
      DISCONNECTED: 'Disconnected from Xero',
      DISCONNECT: 'Disconnect from Xero and archive',
    },
    Connect: {
      TITLE: 'Connect a new Entity',
      BODY: 'Your subscription will be automatically adjusted when you connect a new entity',
      CTA: 'Connect a Xero Organisation',
    },
    Reconnect: {
      TITLE: "We don't have a current token for one or more Xero Organisations",
      BODY_1:
        "This means we can't sync information with Xero. Don't worry, it's simple to fix. Just click the button below to go to the Xero connection screen.",
      BODY_2:
        'Hopefully, all the organisations you expect are listed there. If not, please re-connect them, which may require a few round trips if there is more than one missing.',
      CTA: 'Re-connect with Xero',
    },
  },
};
